<template lang="pug">
.chart.comparer(:class="{ 'see-through': roboReportMinimized }")
  .wrap(:class="{ shown: chartShown && !roboReportShown }")
    .close(@click="chartShown = false")
    report-opener
    //.opener(@click="roboReportShown = true")
      .border
      .toggle-robo
        .bars
          .bar.tall.gap
          .bar
          .bar
          .bar.tall
          .bar.gap
          .bar.tall
          .bar
          .bar.tall
          .bar.tall
        .eyes
          .eye
          .eye
      .lines
        .line
        .line
        .line
        .line
        .line
        .line
        .label view report
    global-events(v-if="!selectedParentTheme && !roboReportShown", @keyup.stop.esc="chartShown = false")
    .vis-types
      .outline(:class="{ [selectedVis || 'topThemes']: true }")
      .vis-type(@click="Object.keys(selectedThemes || {}).length && (selectedVis = 'selectedThemes')", :class="{ clickable: themes && themes.length, on: selectedVis === 'selectedThemes' }") selected
      .vis-type(@click="selectedVis = 'topThemes'", :class="{ on: !selectedVis || selectedVis === 'topThemes' }") trending
    .themes(v-if="themes && themes.length")
      global-events(v-if="selectedParentTheme && !roboReportShown", @keyup.stop.esc="selectedParentTheme = null")
      .theme(v-for="{ t, n, th } in themes",
             :key="n",
             :title="selectedVis === 'selectedThemes' && `Deselect ${ t || n }` || ''",
             :class="{ on: selectedVis !== 'selectedThemes' && selectedParentTheme === n, dim: selectedVis !== 'selectedThemes' && selectedParentTheme && (selectedParentTheme !== n) && $store.getters.themes[selectedParentTheme] }"
             @mouseenter="!selectedParentTheme && (hoverTheme = n)",
             @mouseleave="hoverTheme = null",
             @click="themeClick(n)")
        .details
          .close(v-if="selectedVis === 'selectedThemes'") &times;
          .label.top {{ t || n }}
          .label {{ t || n }}
          .bg(v-if="th" :style="{ 'background-image': beenShown && `url('${ th && th.url }')` }")
    .top
      .bar
        //-todo: adjust position sticky to account for this now being present
        .favicons(v-if="true || Object.keys(publishers || {}).length > 1")
          .favicon(v-for="({ n, i }, key) in publishers",
            @mouseenter="hoverPub = key",
            @mouseleave="hoverPub = null",
            @click="pubClick(key)",
            :class="{ dim: referencePub && referencePub !== key }",
            :key="key",
            :title="`click to ${ referencePub === key && 'un' || '' }set ${ n } as reference publisher`"
            :style="{ 'background-image': `url('${ i }')` }")
            .label {{ n }}
        .leadingTrailing(:class="{ hide: !referencePub }")
          .leading(@click="leadingTrailing = true", :class="{ selected: leadingTrailing }") leading
          .trailing(@click="leadingTrailing = false", :class="{ selected: !leadingTrailing }") trailing
      .times
        .title quarters:
        .time(v-for="time in times",
              @mouseenter="hoverTime = time",
              @mouseleave="hoverTime = null",
              :key="time",
              :class="{ on: hoverTime === time }") {{ qLabel(time).replace(/(\d\d)Q1|\d\d(Q[234])/g, '$1$2').replace(/(\d\d)/, '20$1') }}
    .groups
      .group(v-if="themes && themes.length", :class="{ 'has-pin': !!hoverTheme }")
        .by-theme(v-for="{ t, n, th } in childThemes || themes",
                  :key="n",
                  :class="{ 'has-hover': !!hoverPub, pin: hoverTheme === n }")
          .top
            .title(@click="selectedVis !== 'selectedThemes' && !(childThemes && childThemes.length) &&  themeClick(n)",
                   :class="{ clickable: selectedVis !== 'selectedThemes' && !(childThemes && childThemes.length) }") {{ t || n }}
          .rows
            .row(v-for="({ wt }, key) in mergedWeights(n)",
                 :class="{ on: key === hoverPub }",
                 :key="key",
                 v-observe-visibility="{ once: true, callback: isVisible => isVisible && (visibleRows[key] = true) }",
                 :rank="rspRank(n, key)",
                 :style="{ order: rspRank(n, key) + 1 }",
                 :title="publishers[key] && publishers[key].n")
              .favicon(:class="{ [key]: true }",
                       v-if="publishers[key]",
                       :title="totalRsps(wt)",
                       :style="{ transform: `translate3d(${ weight(lastValue(wt)) }, 0, 0)`, 'background-image': visibleRows[key] && `url('${ publishers[key] && publishers[key].i }')` }")
                .label {{ publishers[key] && publishers[key].n }}
              .dashes(:style="{ transform: `translate3d(${ weight(lastValue(wt)) }, 0, 0)` }")
              .history(v-if="visibleRows[key]")
                .past(v-for="({ rs: value, rsp }, time) in wt",
                      :key="time",
                      @mouseenter="hoverTime = time",
                      @mouseleave="hoverTime = null",
                      :class="{ on: hoverTime === time }",
                      :rsp="quantile(rsp)",
                      :title="title(time)",
                      :style="{ transform: `translate3d(${ weight(value) }, 0, 0) scale(${ hoverTime === time && 1.5 || 1 })` }") {{ qLabel(time) }}
  robo-report(v-if="roboReportBeenShown || roboReportLaunchedFromWatchList")
    //-.group(v-if="topThemes && topThemes.length&& (!selectedVis || selectedVis === 'topThemes')", :class="{ 'has-pin': !!hoverTheme }")
    //-  .by-theme(v-for="{ t, n, th } in topThemes",
    //-            :key="n",
    //-            :class="{ 'has-hover': !!hoverPub, pin: hoverTheme === n }")
    //-    .top
    //-      .title {{ t }}
    //-    .rows
    //-      .row(v-for="({ wt }, key) in mergedWeights(n)",
    //-           :class="{ on: key === hoverPub }",
    //-           :key="key",
    //-           :rank="rspRank(n, key)",
    //-           :style="{ order: rspRank(n, key) + 1 }",
    //-           :title="publishers[key] && publishers[key].n")
    //-        .favicon(:class="{ [key]: true }",
    //-                 :title="totalRsps(wt)",
    //-                 :style="{ transform: `translate3d(${ weight(lastValue(wt)) }, 0, 0)`, 'background-image': `url('${ publishers[key] && publishers[key].i }')` }")
    //-          .label {{ publishers[key] && publishers[key].n }}
    //-        .history
    //-          .past(v-for="({ rs: value, rsp }, time) in wt",
    //-                :key="time",
    //-                @mouseenter="hoverTime = time",
    //-                @mouseleave="hoverTime = null",
    //-                :class="{ on: hoverTime === time }",
    //-                :rsp="quantile(rsp)",
    //-                :title="title(time)",
    //-                :style="{ transform: `translate3d(${ weight(value) }, 0, 0) scale(${ hoverTime === time && 1.5 || 1 })` }") {{ qLabel(time) }}
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
import reportOpener from '@/components/report-opener';
export default {
  name: 'comparer',
  data() {
    return {
      beenShown: false,
      roboReportBeenShown: false,
      weights: {},
      visibleRows: {},
      NOTweights: {
        total: {
          NOTwt: 0.744,
          wt: {
            '2018-Q3': { rs: 0.01241 },
            '2018-Q4': { rs: 0.08242 },
            '2019': { rs: 0.1139 },
            '2019-Q2': { rs: 0.1526 },
            '2019-Q3': { rs: 0.2175 },
            '2019-Q4': { rs: 0.2327 },
            '2020': { rs: 0.2424 },
            '2020-Q2': { rs: 0.3988 }
          }
        },
        bp: {
          NOTwt: 0.894,
          wt: {
            '2018-Q3': { rs: 0.1019 },
            '2018-Q4': { rs: 0.1812 },
            '2019': { rs: 0.2956 },
            '2019-Q2': { rs: 0.3765 },
            '2019-Q3': { rs: 0.4266 },
            '2019-Q4': { rs: 0.5438 },
            '2020': { rs: 0.6234 },
            '2020-Q2': { rs: 0.7575 }
          }
        },
        chevron: {
          NOTwt: 0.64,
          wt: {
            '2018-Q3': { rs: 0.06149 },
            '2018-Q4': { rs: 0.2542 },
            '2019': { rs: 0.2836 },
            '2019-Q2': { rs: 0.31 },
            '2019-Q3': { rs: 0.3246 },
            '2019-Q4': { rs: 0.4992 },
            '2020': { rs: 0.5325 },
            '2020-Q2': { rs: 0.61 }
          }
        },
        shell: {
          NOTwt: 0.24,
          wt: {
            '2018-Q3': { rs: 0.02697 },
            '2018-Q4': { rs: 0.03552 },
            '2019': { rs: 0.08729 },
            '2019-Q2': { rs: 0.09261 },
            '2019-Q3': { rs: 0.09511 },
            '2019-Q4': { rs: 0.09844 },
            '2020': { rs: 0.1833 },
            '2020-Q2': { rs: 0.1911 }
          }
        },
        exxon: {
          NOTwt: 0.84,
          wt: {
            '2018-Q3': { rs: 0.0458 },
            '2018-Q4': { rs: 0.05924 },
            '2019': { rs: 0.1945 },
            '2019-Q2': { rs: 0.2763 },
            '2019-Q3': { rs: 0.3673 },
            '2019-Q4': { rs: 0.3954 },
            '2020': { rs: 0.4585 },
            '2020-Q2': { rs: 0.7478 }
          }
        },
        aramco: {
          NOTwt: 0.54,
          wt: {
            '2018-Q3': { rs: 0.04879 },
            '2018-Q4': { rs: 0.08719 },
            '2019': { rs: 0.09464 },
            '2019-Q2': { rs: 0.148 },
            '2019-Q3': { rs: 0.2187 },
            '2019-Q4': { rs: 0.2679 },
            '2020': { rs: 0.3192 },
            '2020-Q2': { rs: 0.406 }
          }
        },
        cnpc: {
          NOTwt: 0.34,
          wt: {
            '2018-Q3': { rs: 0.08597 },
            '2018-Q4': { rs: 0.1036 },
            '2019': { rs: 0.1993 },
            '2019-Q2': { rs: 0.2017 },
            '2019-Q3': { rs: 0.2252 },
            '2019-Q4': { rs: 0.2342 },
            '2020': { rs: 0.2802 },
            '2020-Q2': { rs: 0.301 }
          }
        }
      }
    };
  },
  watch: {
    chartShown() {
      this.beenShown = true;
    },
    roboReportShown() {
      console.log('roboReportShown watcher');
      this.roboReportBeenShown = true;
    },
    leadingTrailing() {
      this.roboReport = null;
    }
  },
  computed: {
    ...mapGetters(['roboReportLaunchedFromWatchList']),
    ...vuexComputed(
      'analytics',
      'hoverTime',
      'selectedThemes',
      'hoverPub',
      'topParentThemes',
      'chartShown',
      'hoverTheme',
      'selectedVis',
      'selectedParentTheme',
      'childThemes',
      'referencePub',
      'leadingTrailing',
      'roboReportShown',
      'roboReportMinimized',
      'roboReport'
    ),
    themes() {
      const { selectedThemes, topParentThemes, selectedVis, $store: { getters: { themes } } } = this;
      // console.log('computed themes', topParentThemes, (selectedVis === 'selectedThemes' && Object.keys(selectedThemes) || topParentThemes)
      //   .filter(n => themes[n])
      //   .map(n => themes[n]));
      return (selectedVis === 'selectedThemes' && Object.keys(selectedThemes) || topParentThemes.map(([n]) => n))
        .filter(n => themes[n])
        .map(n => themes[n]);
    },
    topThemes() {
      const { topParentThemes, $store: { getters: { themes } } } = this;
      return topParentThemes
        .filter(([n]) => themes[n])
        .map(([n]) => themes[n]);
    },
    times() {
      // todo: make dynamic
      return [
        '14.4',
        '15.1', '15.2', '15.3', '15.4',
        '16.1', '16.2', '16.3', '16.4',
        '17.1', '17.2', '17.3', '17.4',
        '18.1', '18.2', '18.3', '18.4',
        '19.1', '19.2', '19.3', '19.4',
        '20.1', '20.2', '20.3', '20.4',
        '21.1', '21.2'
      ];
    },
    publishers() {
      console.log('pubs', this.$store.getters.publishers);
      return this.$store.getters?.publishers || {
        ...this.$store.getters.publishers,
        total: {
          n: 'Total',
          i: 'https://www.total.com/themes/custom/total_com/dist/img/favicon.png'
        },
        bp: {
          n: 'Bp',
          i: 'https://www.bp.com/etc/designs/refresh/bp/favicon.ico'
        },
        chevron: {
          n: 'Chevron',
          i: 'https://www.chevron.com/assets/fav/favicon.ico?v=7k4MjPGMX6'
        },
        shell: {
          n: 'Shell',
          i:
            'https://www.shell.com/apps/settings/wcm/designs/shell-rio/clientlibs/themes/theme-shell/resources/favicon/favicon.ico'
        },
        exxon: {
          n: 'Exxon',
          i: 'https://corporate.exxonmobil.com/-/media/Global/Icons/XX-favicon.ico'
        },
        aramco: {
          n: 'Aramco',
          i: 'https://americas.aramco.com/images/favicon/favicon.ico'
        },
        cnpc: {
          n: 'China National Petroleum Corporation',
          i: 'https://www.cnpc.com.cn/favicon.ico'
        }
      };
    }
  },
  methods: {
    ...mapActions(['toggleTheme']),
    themeClick(n) {
      const { selectedVis, toggleTheme, selectedParentTheme, $store: { getters: { themes } } } = this;
      this.roboReport = null;
      if (selectedVis === 'selectedThemes') {
        toggleTheme(n);
      } else {
        this.selectedParentTheme = (selectedParentTheme !== n && isParentTheme(n) && n) || null;
      }
      this.hoverTheme = null;
      function isParentTheme(n) {
        return !!themes[n]?.cth?.length;
      }
    },
    pubClick(key) {
      this.referencePub = this.referencePub !== key && key || null;
      this.roboReport = null;
    },
    lastValue(wt = {}) {
      const values = Object.values(wt);
      return values[values.length - 1]?.rs;
    },
    mergedWeights(theme) {
      const { $store: { getters: { analytics } } } = this;
      //console.log('mergedWeights', theme, (analytics?.thd?.tht || {})[theme]?.pwt || 'not here');
      return ((analytics?.thd?.tht || {})[theme] || {}).pwt || {};
    },
    weight(value) {
      return `calc(${ value * 100 }vw - 10rem)`;
    },
    quantile(value) {
      return value <= 0.2 && 'one'
        || value <= 0.4 && 'two'
        || value <= 0.6 && 'three'
        || value <= 0.8 && 'four'
        || 'five';
    },
    sortedRsps(theme) {
      const { mergedWeights, totalRsps } = this;
      //console.log('mergedWeights', theme, mergedWeights(theme));//, Object.values(mergedWeights(theme)).map(({ wt }) => totalRsps(wt)));
      return Object.entries(mergedWeights(theme))
        .map(([key, { wt }]) => ({ key, total: totalRsps(wt) }))
        .sort((a, b) => {
          return b.total - a.total;
        });
    },
    totalRsps(wt) {
      return Object.values(wt).reduce((total, { rsp }) => total + rsp * 1, 0);
    },
    rspRank(theme, key) {
      const { sortedRsps } = this;
      //console.log('rspRank', theme, key, sortedRsps(theme));
      return sortedRsps(theme)?.findIndex(item => item.key == key);
    },
    random(value) {
      return (Math.random() * value).toPrecision(4) * 1;
    },
    //past(value) {
    //  const labels = ['2018-Q3', '2018-Q4', '2019', '2019-Q2', '2019-Q3', '2019-Q4', '2020', '2020-Q2'];
    //  const r = Array.from(new Array(8), n => this.random(value))
    //  .sort()
    //  .reduce((all, wt, i) => {
    //    all.push({ time: labels[i], value: wt });
    //    return all;
    //  }, []);
    //  console.log(value, r.map(v => JSON.stringify(v)).join(','));
    //  return r;
    //},
    qLabel(time) {
      return time.replace(/\./, 'Q');
      //return time.replace(/^.+\-/, '');
    },
    title(time) {
      return time.replace(/-/, ' ');
    }
  },
  components: {
    reportOpener,
    roboReport: () => import('@/components/topo-components/robo-report')
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.chart {
  pointer-events: none;
  &.see-through {
    pointer-events: none;
    & > .wrap.shown {
      pointer-events: none;
    }
  }
  & > .wrap {
    background-color: white;
    opacity: 0;
    transition: none;
    pointer-events: none;
    &.shown {
      pointer-events: all;
      transition: opacity 250ms ease-in-out;
      opacity: 1;
    }
    & > .close {
      z-index: 5;
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      cursor: pointer;
      height: 3rem;
      width: 3rem;
      &:hover {
        &::after {
          color: black;
        }
      }
      &::after {
        color: #dadada;
        cursor: pointer;
        content: '\00d7';
        position: absolute;
        top: -0.3rem;
        right: -0rem;
        font-size: 1.25rem;
        //margin-top: -0.05rem;
        //transform: translate3d(0, -70%, 0);
      }
    }
    // opener was here
    & > .vis-types {
      padding: 1rem;
      display: grid;
      grid-template-columns: repeat(2, 5rem);
      grid-column-gap: 0.5rem;
      position: relative;
      .outline {
        position: absolute;
        top: calc(1rem - 1px);
        left: calc(1rem - 1px);
        width: 4.85rem;
        height: 1.16rem;
        pointer-events: none;
        border: 2px solid orange;
        border-radius: 0.125rem;
        transition: transform 150ms ease-in-out;
        will-change: transform;
        &.topThemes {
          transform: translate3d(5.5rem, 0, 0);
        }
      }
      .vis-type {
        cursor: default;
        box-sizing: border-box;
        padding: 0.125rem;
        text-align: center;
        border: 1px solid #dadada;
        border-radius: 0.125rem;
        text-transform: uppercase;
        font-size: 0.8rem;
        color: #8a8a8a;
        &.clickable:hover,
        &.on {
          cursor: pointer;
          border-color: $brn;
          color: $brn;
        }
        //&:first-of-type {
        //  border-top-left-radius: 0.25rem;
        //  border-bottom-left-radius: 0.25rem;
        //}
        //&:last-of-type {
        //  border-top-right-radius: 0.25rem;
        //  border-bottom-right-radius: 0.25rem;
        //}
      }
    }
    & > .top {
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
      background: white;
      z-index: 8;
      padding-bottom: 0.5rem;
    }
    & > .themes {
      margin: 1rem;
      padding: 1.2rem;
      display: grid;
      grid-template-columns: repeat(40, 3.125rem);
      //grid-column-gap: 0.125rem;
      position: relative;
      padding-left: 5rem;
      padding-bottom: 1.5rem;
      max-width: 100vw;
      box-sizing: border-box;
      overflow: auto;
      &::before {
        content: 'themes:';
        position: absolute;
        top: 50%;
        left: 0;
        text-transform: capitalize;
        color: $brn;
        transform: translate3d(0, -50%, 0);
      }
      & > .theme {
        cursor: pointer;
        width: 3rem;
        flex: 0 0 auto;
        //border: 3px solid transparent;
        box-sizing: border-box;
        //padding-bottom: 0.5rem;
        padding: 0 0.25rem;
        //margin: 0.25rem;
        position: relative;
        transition: opacity 250ms ease-in-out;
        will-change: opacity;
        &:hover {
          .details {
            .label.top {
              opacity: 1;
              z-index: 1;
            }
            .close {
              opacity: 1;
            }
          }
        }
        &.dim {
          &:hover {
            opacity: 1;
          }
          opacity: 0.125;
        }
        &.on {
          .details {
            .label {
              opacity: 1;
              &.top {
                opacity: 0;
              }
            }
          }
        }
        .details {
          position: relative;
          .label {
            position: absolute;
            top: 100%;
            margin-top: 0.125rem;
            left: 50%;
            //width: 6rem;
            text-align: center;
            white-space: nowrap;
            padding: 0.125rem;
            background-color: white;
            transform: translate3d(-50%, 0, 0);
            color: $brn;
            opacity: 0;
            transition: opacity 250ms ease-in-out;
            will-change: opacity;
            &.top {
              top: -1.5rem;
            }
            //background-color: $brn
          }
          .close {
            position: absolute;
            top: -0.2rem;
            right: 0.125rem;
            color: white;
            text-shadow: 1px 1px 0 black, -1px -1px 0 black, 0 1px 0 black, 1px 0 0 black, 0 -1px 0 black,
            -1px 0 0 black, 1px 1px 1px black, -1px -1px 1px black, 0 1px 1px black, 1px 0 1px black,
            0 -1px 1px black, -1px 0 1px black;
            opacity: 0;
            transition: opacity 250ms ease-in-out;
            will-change: opacity;
          }
          .title {
            white-space: nowrap;
            overflow:  hidden;
            text-overflow: ellipsis;
          }
          .bg {
            width: 100%;
            padding-top: 145%;
            background: no-repeat top center;
            background-size: cover;
          }
        }
      }
    }
    .group {
      //min-height: 110vh;
      position: relative;
      &.has-pin {
        .by-theme {
          opacity: 0;
        }
      }
      .by-theme {
        background-color: white;
        border-bottom: 1px solid #ececec;
        padding-bottom: 0.5rem;
        margin: 0.75rem;
        margin-bottom: 1rem;
        &.pin {
          position: absolute;
          top: -0.8rem;
          left: 0;
          right: 0;
          z-index: 10;
          opacity: 1;
        }
        & > .top {
          position: sticky;
          top: 6.75rem;
          left: 0;
          right: 0;
          z-index: 6;
          //height: 5rem;
          background: white;
          box-shadow: 0 0 3px #ececec;
          padding-top: 0.75rem;
          padding-bottom: 0.5rem;
          & > .title {
            text-align: left;
            font-size: 1.7rem;
            padding-left: 0.5rem;
            margin-bottom: 0.5rem;
            transform-origin: left center;
            color: $brn;
            &.clickable {
              cursor: pointer;
            }
          }
        }
        &.has-hover {
          & > .top > .title {
            transition: all 200ms ease-in-out;
            transform-origin: left center;
            margin-bottom: -250%;
            transform: scale(0.5);
          }
          .rows {
            .row {
              transition: all 200ms ease-in-out;
              &.on {
                transform: none;
              }
              &:not(.on) {
                max-height: 0;
              }
            }
          }
        }
      }
    }
    .bar {
      display: grid;
      grid-template-columns: 1fr 12rem;
    }
    .leadingTrailing {
      display: grid;
      grid-template-columns: 4.5rem 4.5rem;
      margin-top: 2.5rem;
      height: 1.25rem;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
      &.hide {
        opacity: 0;
        pointer-events: none;
      }
      .leading,
      .trailing {
        text-transform: uppercase;
        font-size: 0.8rem;
        box-sizing: border-box;
        padding: 0.125rem 0.5rem;
        border: 1px solid transparent;
        border-radius: 0.125rem;
        cursor: pointer;
        transition: border-color 250ms ease-in-out;
        will-change: border-color;
        &.selected {
          cursor: default;
          border-color: orange;
        }
      }
    }
    .favicons {
      //position: sticky;
      //top: 0;
      //left: 0;
      //right: 0;
      overflow: auto;
      //background: white;
      //z-index: 7;
      margin: 1rem;
      display: grid;
      grid-template-columns: repeat(30, 2rem);
      grid-column-gap: 0.5rem;
      position: relative;
      padding: 1rem 1rem 1rem 5.75rem;
      &::before {
        content: 'companies:';
        text-transform: capitalize;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate3d(0, -50%, 0);
        color: $brn;
      }
    }
    .top {
      .times {
        position: relative;
        display: flex;
        padding-left: 5.75rem;
        box-sizing: border-box;
        max-width: 100vw;
        grid-gap: 0.5rem;
        .title {
          position: absolute;
          top: 0;
          left: 1rem;
          text-transform: capitalize;
          color: $brn;
        }
        .time {
          width: auto;
          //margin: 0 0.5rem;
          font-size: 0.75rem;
          color: $brn;
          padding: 0.125rem 0.5rem;
          border: 1px solid rgba($brn, 0.25);
          border-radius: 0.25rem;
          transition: all 250ms ease-in-out;
          cursor: default;
          &.on {
            color: white;
            background-color: $brn;
          }
        }
      }
    }
    .rows {
      position: relative;
      //transform: translate3d(0, 1.5rem, 0) scale(1.5);
      transform-origin: left center;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      .row {
        position: relative;
        //position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin-bottom: 0.125rem;
        overflow: hidden;
        transition: transform 250ms ease-in-out;
        max-height: 2rem;
        padding-left: 1.5rem;
        &:hover {
          .favicon {
            .label {
              opacity: 1;
            }
          }
        }
        .favicon {
          z-index: 3;
          &:hover {
            & > .label {
              //opacity: 0.8;
            }
          }
          & > .label {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate3d(2.5rem, -50%, 0);
            pointer-events: all;
            padding: 0.125rem 0.5rem;
            background-color: $brn;
            color: white;
            border-radius: 0.25rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 5.5rem;
            z-index: 5;
            //border: 1px solid #ccc;
            //box-shadow: 0 0 1px #cecece;
          }
        }
        .dashes {
          height: 1px;
          width: 1px;
          position: relative;
          top: -1rem;
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            right: 100%;
            font-size: 1px;
            border-top: 2px dashed rgba($brn, 0.25);
            transform: translate3d(-0.75rem, -1px, 0);
            width: 100vw;
          }
        }
        & > .history > .past {
          position: absolute;
          top: 0.5rem;
          left: 0;
          font-size: 0.6rem;
          z-index: 2;
          background-color: white;
          padding: 0.125rem;
          padding-right: 0.35rem;
          border-radius: 0.125rem;
          border-top-right-radius: 100%;
          border-bottom-right-radius: 100%;
          cursor: default;
          border: 1px solid rgba($brn, 0.25);
          color: $brn;
          pointer-events: all;
          transition: all 250ms ease-in-out;
          transform-origin: center;
          &.on {
            background-color: $brn;
            color: white;
            z-index: 4;
          }
          &[rsp='one'] {
            border-color: rgba($brn, 0.5);
            &.on {
              background-color: rgba($brn, 0.5);
            }
          }
          &[rsp='two'] {
            border-color: $brn;
            &.on {
              background-color: rgba($brn, 0.5);
            }
          }
          &[rsp='three'],
          &[rsp='four'],
          &[rsp='five'] {
            border-color: $brn;
            box-shadow: -1px 0 2px rgba($brn, 0.5);
            &.on {
              background-color: $brn;
            }
          }
          &[rsp='four'] {
            box-shadow: -1px 0 3px rgba($brn, 0.5),
            -3px 0 1px rgba($brn, 0.5);
          }
          &[rsp='five'] {
            box-shadow: -1px 0 4px rgba($brn, 0.5),
            -3px 0 1px rgba($brn, 0.5),
            -6px 0 1px rgba($brn, 0.75);
          }
          &:last-of-type {
            display: none;
          }
        }
      }
    }
    .favicon {
      width: 2rem;
      height: 2rem;
      background: no-repeat center;
      background-size: contain;
      position: relative;
      &.dim {
        &:hover {
          opacity: 1;
        }
        opacity: 0.125;
      }
      //&.total {
      //  background-image: url('https://www.total.com/themes/custom/total_com/dist/img/favicon.png');
      //}
      //&.bp {
      //  background-image: url('https://www.bp.com/etc/designs/refresh/bp/favicon.ico');
      //}
      //&.chevron {
      //  background-image: url('https://www.chevron.com/assets/fav/favicon.ico?v=7k4MjPGMX6');
      //}
      //&.shell {
      //  background-image: url('https://www.shell.com/apps/settings/wcm/designs/shell-rio/clientlibs/themes/theme-shell/resources/favicon/favicon.ico');
      //}
      //&.exxon {
      //  background-image: url('https://corporate.exxonmobil.com/-/media/Global/Icons/XX-favicon.ico');
      //}
      //&.aramco {
      //  background-image: url('https://americas.aramco.com/images/favicon/favicon.ico');
      //}
      //&.cnpc {
      //  background-image: url('https://www.cnpc.com.cn/favicon.ico');
      //}
      &:hover > .label {
        opacity: 1;
      }
      & > .label {
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate3d(-50%, 0.25rem, 0);
        white-space: nowrap;
        text-transform: uppercase;
        font-size: 0.8rem;
        color: $brn;
        opacity: 0;
        transition: opacity 250ms ease-in-out;
        will-change: opacity;
        pointer-events: none;
      }
    }
  }
}
</style>
